<template>
  <div class="container">
    <p :class="isTitle ? 'title' : ''" class="marginBottom18">
      {{ title }}
    </p>
    <image-component
      path=""
      :is_jpg="is_jpg ? '' : false"
      :name="ImgTitle"
    ></image-component>
    <slot name="content">{{ content }}</slot>
  </div>
</template>

<script>
import ImageComponent from "../../components/imageComponent.vue";
export default {
  components: {ImageComponent},
  props: {
    ImgTitle: String,
    title: String,
    content: String,
    isTitle: {
      type: Boolean,
      default: false,
    },

    is_jpg: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style scoped>
.container {
  width: 218px;
}

.title {
  width: 100%;
  border-radius: 49px;
  background-color: #ff5230;
  color: #fff;
  font-size: 1rem;
  padding: 0.9rem 0;
}
</style>
